/* eslint-disable prefer-template */
/* eslint-disable prefer-object-spread */
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Button, Grid, Header } from "semantic-ui-react";

// material
import { styled } from "@mui/material/styles";
import { Container, Box } from "@mui/material";
import MyTextInput from "../components/common/form/MyTextInput";

// components
import Page from "../components/Page";
import ClientMenuLeft from './common/ClientMenuLeft';
import DisplayCognitoError from "../components/common/DisplayCognitoError";

import { checkEmailStart } from "../redux/auth/auth.actions";


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function AdminPasswordForgot() {
  const { currentError } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Adresse e-mail est un champ obligatoire")
      .email("Le champ e-mail n'est pas valide"),
  });

  const handleSubmit = (values, { resetForm }) => {
    try {
      const payload = {
        navigate: navigate,
        email: values.email,
        redirectPath: "/admin-password-code",
      };

      dispatch(checkEmailStart(payload));
      window.localStorage.setItem("emailAdminResetPassword", values.email);
      resetForm();

 
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <RootStyle title=" Administration des plaintes | Gestion des plaintes">
    <ClientMenuLeft />
      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Header as="h2" color="blue" textAlign="center">
              Retrouvez votre compte
            </Header>
          </Box>
          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <DisplayCognitoError errorMessage={currentError} />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                <Form className="ui form">
                  <MyTextInput
                    label="Veuillez entrer votre adresse e-mail pour rechercher votre compte."
                    name="email"
                    placeholder="Adresse e-mail"
                  />

                  <Button
                    type="submit"
                    fluid
                    size="large"
                    color="blue"
                    content="Envoyer le code de vérification"
                  />
                </Form>
              </Formik>
            </Grid.Column>
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
